<button mat-menu-item (click)="onClick()" [disabled]="disabled" fxLayoutAlign="start center" [style.height.px]="height" [style.line-height.px]="height">
    <mat-icon [class]="className" fxLayoutAlign="start center" [svgIcon]="icon"></mat-icon>
    <span [class]="className">{{ label }}</span><ng-content></ng-content>
</button>
